import { supabase } from "@/lib/supabase";

export interface Organization {
  id: string;
  name: string;
  slug: string | null;
  created_at: string;
}

/** Orgs the signed-in user belongs to. New sign-ups are auto-joined to the
 *  default Prado org by a DB trigger (see 0001_initial_schema.sql), so this is
 *  populated immediately after the first login. */
export async function getMyOrganizations(): Promise<Organization[]> {
  const { data, error } = await supabase
    .from("org_members")
    .select("org_id, organizations(id, name, slug, created_at)")
    .order("created_at", { ascending: true });
  if (error) throw error;
  return (data ?? [])
    .map((row) => (row as unknown as { organizations: Organization | null }).organizations)
    .filter((org): org is Organization => !!org);
}
